export default __webpack_public_path__ + "static/media/fastResponses.96d7f902.png";